export const MOUSE_DOWN_EVENT = 'mousedown';
export const MOUSE_UP_EVENT = 'mouseup';
export const MOUSE_MOVE_EVENT = 'mousemove';
export const CLICK_EVENT = 'click';
export const KEY_DOWN_EVENT = 'keydown';
export const INPUT_EVENT = 'input';
